import type { SVGProps } from 'react';

const SvgReports = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="reports">
      <path d="M6.52 7.45h.84V6h-.84a2.6 2.6 0 0 0-2.6 2.6v20.09a2.75 2.75 0 0 0 2.75 2.75h18.8a2.76 2.76 0 0 0 2.75-2.75V8.55A2.6 2.6 0 0 0 25.61 6H24.4v1.5h1.21a1.11 1.11 0 0 1 1.11 1.1v20.09a1.26 1.26 0 0 1-1.25 1.25H6.67a1.26 1.26 0 0 1-1.25-1.25V8.55a1.1 1.1 0 0 1 1.1-1.1" />
      <path d="M23.16 8.11V5.84A1.86 1.86 0 0 0 21.28 4h-1.62l-.1-.52a3.75 3.75 0 0 0-7.32 0l-.1.52h-1.58a1.85 1.85 0 0 0-1.88 1.84v2.27a.76.76 0 0 0 .75.75h13a.76.76 0 0 0 .73-.75m-1.5-.75H10.18V5.84a.36.36 0 0 1 .38-.33h2.2a.73.73 0 0 0 .73-.61l.22-1.12a2.25 2.25 0 0 1 4.38 0l.22 1.12a.73.73 0 0 0 .73.61h2.24a.36.36 0 0 1 .38.33ZM16.32 13.95h6.4v1.5h-6.4zM9.21 19.8h13.51v1.5H9.21zM13.8 17.57a.75.75 0 0 0 .75-.75v-4.25a.75.75 0 0 0-.75-.75H9.52a.74.74 0 0 0-.75.75v4.25a.74.74 0 0 0 .75.75Zm-3.53-4.25h2.78v2.75h-2.78ZM9.21 24.45h13.51v1.5H9.21z" />
    </g>
  </svg>
);

export default SvgReports;
